<template>
  <div class="feed-page">
    <v-container fluid grid-list-xl>
      <v-layout row wrap>
        <v-flex xs12>
          <div class="list-hero">
            <p class="list-crumb">Notificaciones</p>
            <h1 class="list-title">Notificaciones</h1>
            <p class="list-subtitle">
              Actividad y avisos recientes del sistema TRANSIT.
            </p>
          </div>
        </v-flex>

        <v-flex xs12>
          <v-card class="feed-card">
            <div class="feed-toolbar">
              <span class="feed-chip">
                <v-icon small class="feed-chip__icon">notifications</v-icon>
                {{ feeds.length }} notificación(es)
              </span>
            </div>
            <v-divider></v-divider>

            <div v-if="feeds.length > 0" class="feed-list">
              <div
                v-for="(item, index) in feeds"
                :key="index"
                class="feed-item"
              >
                <div class="feed-item__icon">
                  <v-icon>notifications_active</v-icon>
                </div>
                <div class="feed-item__body">
                  <p class="feed-item__title">
                    {{ item.userComment || 'Sin descripción' }}
                  </p>
                  <div class="feed-item__meta">
                    <span v-if="item.invoiceId" class="feed-tag">
                      Factura #{{ item.invoiceId }}
                    </span>
                    <span v-if="item.action" class="feed-item__action">
                      {{ item.action }}
                    </span>
                  </div>
                </div>
                <div class="feed-item__time">{{ item.dateComment }}</div>
              </div>
            </div>

            <div v-else class="feed-empty">
              <v-icon class="feed-empty__icon">notifications_none</v-icon>
              <p class="feed-empty__title">
                Bienvenido al Sistema de Notificaciones de TRANSIT
              </p>
              <p class="feed-empty__text">Aún no tienes notificaciones.</p>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      feeds: state => state.feeds.all,
    }),
  },
  created() {
    this.$store.dispatch('feeds/getAll')
  },
}
</script>

<style scoped src="./feed-list.css"></style>
